/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Year_BuiltInputs */

const en_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year Built`)
};

const es_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Año de construcción`)
};

const fr_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Année de construction`)
};

const de_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baujahr`)
};

const ja_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`築年数`)
};

const zh_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建成年份`)
};

const ar_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنة البناء`)
};

const id_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahun Dibangun`)
};

const it_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anno di Costruzione`)
};

const ru_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Год постройки`)
};

const pt_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano de Construção`)
};

const ko_field_year_built = /** @type {(inputs: Field_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`건축 연도`)
};

/**
* | output |
* | --- |
* | "Year Built" |
*
* @param {Field_Year_BuiltInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_year_built = /** @type {((inputs?: Field_Year_BuiltInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Year_BuiltInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_year_built(inputs)
	if (locale === "es") return es_field_year_built(inputs)
	if (locale === "fr") return fr_field_year_built(inputs)
	if (locale === "de") return de_field_year_built(inputs)
	if (locale === "ja") return ja_field_year_built(inputs)
	if (locale === "zh") return zh_field_year_built(inputs)
	if (locale === "ar") return ar_field_year_built(inputs)
	if (locale === "id") return id_field_year_built(inputs)
	if (locale === "it") return it_field_year_built(inputs)
	if (locale === "ru") return ru_field_year_built(inputs)
	if (locale === "pt") return pt_field_year_built(inputs)
	return ko_field_year_built(inputs)
});